var expand_deck = function(deckId) {
  var tr = $(".tournament-decklist[data-deckid='" + deckId + "']");
  tr.toggle();
  toggle_deck_update(deckId);
}

window.expand_deck = expand_deck

var toggle_deck_update = function(deckId) {
  var tr = $(".tournament-decklist[data-deckid='" + deckId + "']");
  if (tr.is(":visible")) {
    $(".tournament-decklist-toggle[data-deckid='" + deckId + "'] a").text("Collapse");
  } else {
    $(".tournament-decklist-toggle[data-deckid='" + deckId + "'] a").text("Expand");
  }

  if (!tr.data("loaded")) {
    tr.attr("data-loaded", true);
    $.ajax({
        url: "/widgets/deck/js",
        cache: false,
        type: "GET",
        dataType: "script",
        data: {
          deckId: deckId
        }
    });
  }
}

const getParameterByName = (name) => {
    var query = window.location.search.toString();
    name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
    var regexS = "[\\?&]" + name + "=([^&#]*)";
    var regex = new RegExp(regexS);
    var results = regex.exec(query);
    if (results == null) return "";
    else return decodeURIComponent(results[1].replace(/\+/g, " "));
}

$(function() {
  $(".widget-deck-placeholder").each(function() {
    var params = $(this).data("params");
    var url = "/widgets/deck/js";
    var domId = $(this).attr('id');


    var utmSource = getParameterByName('utm_source');
    var utmMedium = getParameterByName('utm_medium');
    var utmContent = getParameterByName('utm_content');
    var utmCampaign = getParameterByName('utm_campaign');

    url += "?utm_source=" + utmSource;
    url += "&utm_medium=" + utmMedium;
    url += "&utm_content=" + utmContent;

    // take the article's campaign to be priority
    if (typeof $utm_campaign !== 'undefined') {
      url += "&utm_campaign=" + $utm_campaign;
    } else if (utmCampaign) {
      url += "&utm_campaign=" + utmCampaign;
    }

    if (typeof params !== 'undefined') {
      url += "&" + params;
    }

    $.ajax({
        url: url,
        cache: false,
        type: "GET",
        dataType: "script",
        data: {
          deckId: $(this).data("id"),
          domId: domId
        }
    });
  });
  window.MTGGoldfish_DeckWidget = true;
});

$(".tournament-decklist-collapse").click(function(e) {

  var new_option;
  var new_value;

  console.log("Expand/Collapse All");
  if ($(e.target).text() == "Collapse Decks") {
    new_option = "Expand Decks";
    new_value = false;
  } else {
    new_option = "Collapse Decks"; 
    new_value = true;
  }
  $(".tournament-decklist-collapse").text(new_option);

  $(".tournament-decklist").each(function() {
    console.log("Expand/Collapse Each");
    $(this).toggle(new_value);
    toggle_deck_update($(this).data("deckid"));
  });

});
